import {ActionLink} from "nhsuk-react-components"
import React, {useContext} from "react"
import {AppContext} from "../../index"
import styled from "styled-components"

export interface PrescriptionActionsProps extends Actions {
  prescriptionId: string
  direction?: "column" | "row"
}

export interface Actions {
  cancel?: boolean
  release?: boolean
  releaseReturn?: boolean
  dispense?: boolean
  withdraw?: boolean
  claim?: boolean
  claimAmend?: boolean
  statusView?: boolean
  summaryView?: boolean
}

const ActionsLayout = styled.div<{$direction: "column" | "row"}>`
  display: flex;
  flex-direction: ${props => props.$direction};
  gap: 16px; 
  flex-wrap: wrap; 
  align-items: ${props => props.$direction === "column" ? "flex-start" : "center"};
  margin-left: 5px;
  padding-bottom: ${props => props.$direction === "column" ? "32px" : "none"};
  
  div {
    height: ${props => props.$direction === "column" ? "5px" : "none"};
    margin-left: ${props => props.$direction === "column" ? "none" : "15px"};
    padding-top: ${props => props.$direction === "column" ? "15px" : "none"};
  }
`

const PrescriptionActions: React.FC<PrescriptionActionsProps> = ({
  prescriptionId,
  direction = "row", // Fallback default value
  ...actions
}) => {
  const {baseUrl} = useContext(AppContext)

  // 3. Replaced <Container> with <ActionsLayout> and passed down the direction prop
  return (
    <ActionsLayout $direction={direction}>
      {actions.cancel && (
        <ActionLink href={`${baseUrl}prescribe/cancel?prescription_id=${encodeURIComponent(prescriptionId)}`}>
          Cancel prescription
        </ActionLink>
      )}
      {actions.release && (
        <ActionLink href={`${baseUrl}dispense/release?prescription_id=${encodeURIComponent(prescriptionId)}`}>
          Release prescription
        </ActionLink>
      )}
      {actions.releaseReturn && (
        <ActionLink href={`${baseUrl}dispense/return?prescription_id=${encodeURIComponent(prescriptionId)}`}>
          Return prescription
        </ActionLink>
      )}
      {actions.dispense && (
        <ActionLink href={`${baseUrl}dispense/dispense?prescription_id=${encodeURIComponent(prescriptionId)}`}>
          Dispense prescription
        </ActionLink>
      )}
      {actions.withdraw && (
        <ActionLink href={`${baseUrl}dispense/withdraw?prescription_id=${encodeURIComponent(prescriptionId)}`}>
          Withdraw prescription
        </ActionLink>
      )}
      {actions.claim && (
        <ActionLink href={`${baseUrl}dispense/claim?prescription_id=${encodeURIComponent(prescriptionId)}`}>
          Claim for prescription
        </ActionLink>
      )}
      {actions.claimAmend && (
        <ActionLink href={`${baseUrl}dispense/claim?prescription_id=${encodeURIComponent(prescriptionId)}&amend=true`}>
          Amend the claim on this prescription
        </ActionLink>
      )}
      {actions.statusView && (
        <ActionLink href={`${baseUrl}view?prescription_id=${encodeURIComponent(prescriptionId)}`}>
          Check prescription status
        </ActionLink>
      )}
    </ActionsLayout>
  )
}

// 4. Exporting the functional component itself
export default PrescriptionActions
